/* eslint-disable */
import * as util from "@/api/tour";

const state = {

};


const mutations = {
};

const actions = {
    tourDetail({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.tourDetail(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    tourComplete({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.tourComplete(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    updateHasTourIntroduction({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.updateHasTourIntroduction(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/tour.js